import { ApiCall } from '../../fromKotlin/nk';

export type HashIsraelResetResult = { ok: true } | { ok: false; error: string };

/**
 * Clears `tax_invoice.token` and `tax_invoice.refresh` via Kotlin pipeline
 * (`Tasks.RESET_HASH_ISRAEL_STORED_TOKENS` → UINKDBInterface → NKAdapter → `/hashisrael/reset`).
 */
export async function resetHashIsraelStoredTokens(): Promise<HashIsraelResetResult> {
    try {
        const req = new ApiCall('RESET_HASH_ISRAEL_STORED_TOKENS');
        await req.execute();
        return { ok: true };
    } catch (e: any) {
        const msg =
            (typeof e === 'string' && e) ||
            e?.status_msg ||
            e?.name ||
            e?.message ||
            'איפוס נכשל';
        return { ok: false, error: String(msg) };
    }
}
